import axios from 'axios';

/**
 * 获取新闻详情
 */
export const getNewsDetail = params => {
  return axios.get('/yongpai-news/api/news/detail/preview',{params : params});
};

export const getLiveMessage = params => {
  return axios.get('/yongpai-news/api/news/live_message_refresh',{params : params});
};

/**
 * 获取最新评论列表
 * @returns {json}
 */
export const getCommentList = params => {
  return axios.get('/yongpai-ugc/api/comment/recent',{params : params});
};

export const getNewsReadCount = params => {
  return axios.get('/yongpai-news/api/news/news_read_count',{params : params});
};













// WEBPACK FOOTER //
// ./src/api/qf/index.js